import styled from "styled-components";
import { WrapperContainer } from "../../components";

export const LanguageListWrapper = styled(WrapperContainer)`
  max-height: 266px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 2px;
  }
`;

export const LanguageSelectorWrapper = styled(WrapperContainer)`
  width: 227px;
  margin-right: -4px;
`;
